"use strict";

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/* globals Taidoc_BLE_Device TD_ReadDateRecordForUser TD_CountRecords TD_ReadBPRecord TD_SetDate TD_TurnOff */
/* exported Taidoc_3128 */

var Taidoc_3128_reader = function (_BleReaderTD) {
  _inherits(Taidoc_3128_reader, _BleReaderTD);

  function Taidoc_3128_reader() {
    _classCallCheck(this, Taidoc_3128_reader);

    return _possibleConstructorReturn(this, (Taidoc_3128_reader.__proto__ || Object.getPrototypeOf(Taidoc_3128_reader)).apply(this, arguments));
  }

  _createClass(Taidoc_3128_reader, [{
    key: "commandList",
    value: function commandList() {
      return [new TD_CountRecords(this), new TD_ReadBPDateRecord(this, 1, 0), new TD_ReadBPDateRecord(this, 2, 0), new TD_ReadBPDateRecord(this, 3, 0), new TD_ReadBPDateRecord(this, 4, 0), new TD_ReadBPRecord(this, 1, 0), new TD_ReadBPRecord(this, 2, 0), new TD_ReadBPRecord(this, 3, 0), new TD_ReadBPRecord(this, 4, 0), new TD_ClearBPRecords(this, 1), new TD_ClearBPRecords(this, 2), new TD_ClearBPRecords(this, 3), new TD_ClearBPRecords(this, 4), new TD_SetDate(this), new TD_TurnOff(this)];
    }
  }, {
    key: "onConnect",
    value: function () {
      var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(params) {
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                return _context.abrupt("return", this.getBatteryStatus());

              case 1:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function onConnect(_x) {
        return _ref.apply(this, arguments);
      }

      return onConnect;
    }()
  }]);

  return Taidoc_3128_reader;
}(BleReaderTD);

var Taidoc_3128 = new JS.Class(Taidoc_BLE_Device, {

  initialize: function initialize(device_uuid) {
    var name = "Taidoc TD-3128";
    var model_name = "3128";

    this.advertised_name = "TAIDOC TD3128";

    return this.callSuper(name, model_name, device_uuid);
  },

  makeReader: function makeReader() {
    return new Taidoc_3128_reader(this);
  }

});